
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Project/Project.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Project.html');
        
        var script = require('./Project.ts').default;
        module.exports = require('./Project.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    